 <template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body>
        
        
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 新增退款记录
        </div>

        
        <div class="w-el-drawer-body"  v-loading="loading">
           
            
            <el-form :model="form" label-width="120px" size="mini">
                
                
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="关联合同" :error="formError.contract_id?.toString()" prop="contract_id">
                    <crm-contract-select v-model="form.contract_id" @onChange="ContractOnChange" />
                </el-form-item>

                
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="关联客户" :error="formError.customer_id?.toString()" prop="customer_id">
                    <crm-customer-select v-model="form.customer_id" clearable />
                </el-form-item>

                
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="款项日期" :error="formError.pay_date?.toString()" prop="pay_date">
                    <el-date-picker v-model="form.pay_date" value-format="yyyy-MM-dd" type="date" placeholder="请选择款项日期" clearable />
                </el-form-item>

                
                <el-form-item :rules="[{ required: true, message: '必选项' }]" label="款项负责人" :error="formError.user_id?.toString()" prop="user_id">
                    <users-select v-model="form.user_id" />
                </el-form-item>

                
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="款项金额" :error="formError.pay_money?.toString()" prop="pay_money">
                    <el-input-number v-model="form.pay_money" :min="0" :precision="2" label="款项金额" style="width: 35%;" @change="form.pay_money_offset = form.pay_money_performance = form.pay_money"></el-input-number>
                </el-form-item>

                
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="冲销金额" :error="formError.pay_money_offset?.toString()" prop="pay_money_offset">
                    <el-input-number v-model="form.pay_money_offset" :min="0" :precision="2" label="冲销金额" style="width: 35%;"></el-input-number>
                </el-form-item>

                
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="记业绩金额" :error="formError.pay_money_performance?.toString()" prop="pay_money_performance">
                    <el-input-number v-model="form.pay_money_performance" :min="0" :precision="2" label="记业绩金额" style="width: 35%;"></el-input-number>
                </el-form-item>

                
                <el-form-item label="开具发票">
                    <el-checkbox v-model="form.invoice_state">需要开具发票</el-checkbox>
                </el-form-item>

                
                <el-form-item label="款项备注">
                    <el-input v-model="form.describe" type="textarea" :rows="5" placeholder="款项备注"></el-input>
                </el-form-item>
            </el-form>
        </div>

        
        <div class="w-el-drawer-footer">
            <el-button size="medium" @click="Close()">取消 / 返回</el-button>
            <el-button size="medium" type="primary" @click="FormSubmit()" :loading="loading">创建</el-button>
        </div>

    </el-drawer>
</template>
    
<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,

            formError: {},
            form: {
                contract_id: null,
                customer_id: null,
                user_id: null,
                pay_type: 0,
                pay_date: null,
                pay_money: 0,
                pay_money_offset: 0,
                pay_money_performance: 0,
                invoice_state: true,
                describe: null,
            }
        }
    },
    
    methods: {
        Open(config) {
                        if (config) this.form.contract_id = config.contract_id

                        this.visible = true
            this.loading = false
        },
        Close() {
            this.formError = {}
            
            this.form.contract_id = null
            this.form.customer_id = null
            this.form.user_id = null
            this.form.pay_type = 0
            this.form.pay_date = null
            this.form.pay_money = 0
            this.form.pay_money_offset = 0
            this.form.pay_money_performance = 0
            this.form.invoice_state = false
            this.form.describe = null

            this.visible = false
            this.loading = false
        },

        
        
        ContractOnChange(data) {
            this.form.customer_id = data?.customer_id
            this.form.user_id = data?.user_sale
        },
        FormSubmit() {
                        this.loading = true
            this.formError = {}

            this.$http.post('/9api/crm/contract-pay-record/create', this.form).then(rps => {
                
                this.loading = false

                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }

                if (rps.data.state == 'success') {
                    this.$notify.success({
                        title: '提示',
                        message: '记录添加成功',
                        duration: 2000
                    })
                    this.$emit("success")
                    this.Close()
                }
            })
        }
    }
}
</script>